import { useTranslation } from 'react-i18next'

export function HeroSection() {
  const { t } = useTranslation('common')

  return (
    <section
      className="relative w-full h-[70vh] min-h-[500px] max-h-[800px] flex items-end bg-[#FDF8F3] overflow-hidden"
      aria-labelledby="privacy-hero-title"
    >
      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative z-10 mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 pb-24 pt-40">
        <div className="max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#DF631E]" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#DF631E]">
              {t('privacy.hero.badge')}
            </span>
          </div>

          <h1
            id="privacy-hero-title"
            className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#4E2118] leading-[1.05] mb-5"
            style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
          >
            {t('privacy.hero.title')}
          </h1>

          <p className="text-base md:text-lg text-[#4E2118]/60 max-w-lg leading-relaxed">
            {t('privacy.hero.subtitle')}
          </p>
        </div>
      </div>

    </section>
  )
}
